var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_c('footer',{staticClass:"is-dark"},[_c('footer-links')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }